import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  FeatureGroup,
  RoleDetails,
  Level,
  State,
} from '../../utils/types/roles/RolesTypes'

const initialRoleValues: RoleDetails = {
  applicationTypeCode: '',
  application: '',
  roleName: '',
  copyCapabilities: 0,
  role: '',
  roleDescription: '',
  isEdit: false,
}

const addItem = (
  data: FeatureGroup[] = [],
  level: Level,
  parentCode: string,
  newItem: any,
): FeatureGroup[] => {
  if (level === 'root') {
    data?.push(newItem)
  } else if (level === 'sub') {
    for (const item of data) {
      if (item.featureGroupCode === parentCode) {
        if (!item.features) {
          item.features = []
        }
        item?.features?.push(newItem)
      }
    }
  } else if (level === 'leaf') {
    for (const item of data) {
      if (item.features && item.features.length > 0) {
        for (const subItem of item.features) {
          if (subItem.featureCode === parentCode) {
            if (!subItem.capabilities) {
              subItem.capabilities = []
            }
            subItem?.capabilities?.push(newItem)
          }
        }
      }
    }
  }
  return data
}

function removeItem(
  data: FeatureGroup[],
  level: Level,
  code: string,
): FeatureGroup[] {
  if (level === 'root') {
    const index = data.findIndex((item) => item.featureGroupCode === code)
    if (index !== -1) {
      data.splice(index, 1)
    }
    return data
  } else if (level === 'sub') {
    data?.map((item) => {
      if (item.features && item.features.length > 0) {
        const index = item?.features?.findIndex(
          (subItem) => subItem.featureCode === code,
        )
        if (index !== -1) {
          item?.features?.splice(index, 1)
        }
      }
    })
  } else if (level === 'leaf') {
    for (const item of data) {
      if (item.features && item.features.length > 0) {
        for (const subItem of item.features) {
          if (subItem?.capabilities && subItem?.capabilities?.length > 0) {
            const index = subItem.capabilities.findIndex(
              (leafItem) => leafItem.capabilityCode === code,
            )
            if (index !== -1) {
              subItem.capabilities.splice(index, 1)
            }
          }
        }
      }
    }
  }
  return data
}

const rolesReducer = createSlice({
  name: 'roleCapabilities',
  initialState: {
    roleDetails: initialRoleValues,
    capabilityDetails: [],
    roleAssignmentMapping: [],
  } as State,
  reducers: {
    addRoleDetails: (state, action: PayloadAction<RoleDetails>) => {
      state.roleDetails = action.payload
    },
    addCapabilityDetails: (
      state,
      action: PayloadAction<{
        newItem: any
        level: Level
        parentCode: string
      }>,
    ) => {
      const { newItem, level, parentCode } = action.payload
      const updatedData = addItem(
        state.capabilityDetails || [],
        level,
        parentCode,
        newItem,
      )
      state.capabilityDetails = updatedData
    },
    addRoleAssignmentmapping: (state, action: PayloadAction<any[]>) => {
      state.roleAssignmentMapping = action.payload
    },
    removeCapabilityDetails: (
      state,
      action: PayloadAction<{ level: Level; featureCode: string }>,
    ) => {
      const { level, featureCode } = action.payload
      const updatedData = removeItem(
        state.capabilityDetails,
        level,
        featureCode,
      )
      state.capabilityDetails = updatedData
    },
    replaceCapabilityDetails: (
      state,
      action: PayloadAction<FeatureGroup[]>,
    ) => {
      state.capabilityDetails = action.payload
    },
    resetRoleDetails: (state) => {
      state.roleDetails = initialRoleValues
    },
    resetCapabilityDetails: (state) => {
      state.capabilityDetails = []
    },
    resetRoleAssignmentMapping: (state) => {
      state.roleAssignmentMapping = []
    },
  },
})

export const {
  addRoleDetails,
  addCapabilityDetails,
  addRoleAssignmentmapping,
  removeCapabilityDetails,
  replaceCapabilityDetails,
  resetRoleDetails,
  resetCapabilityDetails,
  resetRoleAssignmentMapping,
} = rolesReducer.actions

export default rolesReducer.reducer
